module.exports = __webpack_public_path__ + "static/doors-a69c86ad2fb26fc9977d3744edc6d5b7.gif";